export const IconButtonPrimary = 'btn btn-primary btn-xs btn-icon-only';
export const IconButtonSecondary = 'btn btn-secondary btn-xs btn-icon-only';
export const IconButtonSuccess = 'btn btn-success btn-xs btn-icon-only';
export const IconButtonDefault = 'btn btn-default btn-xs btn-icon-only';
export const IconButtonDanger = 'btn btn-danger btn-xs btn-icon-only';

export const ProductCellTrackingAction = {
    bookService: 'marketplace.assetOverview.vehicleTable.bookService',
    cancelService: 'marketplace.assetOverview.vehicleTable.cancelService',
    openManageContractsDialog: 'marketplace.assetOverview.vehicleTable.openManageContractsDialog',
    openFreeTrialDialog: 'marketplace.assetOverview.vehicleTable.openFreeTrialDialog',
    pendingActivationInfo: 'marketplace.assetOverview.vehicleTable.pendingActivationInfo',
} as const;

export type ProductCellTrackingActionValue = (typeof ProductCellTrackingAction)[keyof typeof ProductCellTrackingAction];

function toTrackingSegment(value: string) {
    return value
        .trim()
        .replace(/[^A-Za-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function getProductCellAutoTrackingKey(action: ProductCellTrackingActionValue, productLabel: string) {
    const trackingLabel = toTrackingSegment(productLabel);
    return trackingLabel ? `${action}.${trackingLabel}` : action;
}
